import React, { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { saveFavoriteShop } from '../api';
import useCustomerAction from '../hooks/useCustomerAction';
import { useFavoriteShops } from '../hooks/useSellerShops';
import Icon from './Icon';

export default function SaveSellerButton({ sellerId }) {
  const favorites = useFavoriteShops();
  const saved = favorites.data?.some(shop => shop.id === Number(sellerId)) ?? false;
  const authorize = useCustomerAction();
  const queryClient = useQueryClient();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const toggle = async () => {
    if (busy) return;
    setError('');
    setBusy(true);
    try {
      await authorize({ type: 'favorite-seller', sellerId: Number(sellerId) }, async () => {
        try {
          await saveFavoriteShop(sellerId, !saved);
          await queryClient.invalidateQueries({ queryKey: ['favorite-shops'] });
        } catch { setError('Не удалось обновить избранное. Повторите попытку.'); }
      });
    } finally { setBusy(false); }
  };

  return <div className="seller-shop-save">
    <button className="btn btn-outline" type="button" onClick={toggle} disabled={busy || favorites.isFetching} aria-pressed={saved}
      aria-label={saved ? 'Убрать продавца из избранного' : 'Добавить продавца в избранное'}>
      <Icon name="heart" size={17} /> {saved ? 'В избранном' : 'В избранное'}
    </button>
    {(error || authorize.error) && <p role="alert">{error || authorize.error}</p>}
  </div>;
}
